
export const Applications = {
    LOADING_APPLICATIONS_LIST: "LOADING_APPLICATIONS_LIST",
    GET_APPLICATIONS_LIST: "GET_APPLICATIONS_LIST",
  };

